import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth/auth.guard';
import { RoleGuardService } from './auth/role.guard';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { LoginComponent } from './auth/login/login.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CaseComponent } from './case/case.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CompanyGroupListComponent } from './company-groups/company-group-list/company-group-list.component';
import { ConsultantListComponent } from './consultants/consultant-list/consultant-list.component';
import { ActionsComponent } from './actions/actions.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { NewCaseComponent } from './new-case/new-case.component';
import { SearchCaseComponent } from './search-case/search-case.component';
import {UnassignedFilesComponent} from './unassigned-files/unassigned-files.component';
import { LendersListComponent } from './lenders/lenders-list/lenders-list.component';
import { LenderSolicitorsListComponent } from './lender-solicitors/lender-solicitors-list/lender-solicitors-list.component';
import { EmailQueueComponent } from './email-queue/email-queue.component';
import { KlyantComponent } from './klyant/klyant.component';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { MainComponent } from './main/main.component';
import { KlyantAuthComponent } from './klyant/klyant-auth/klyant-auth.component';
import { CompanyGroupComponent } from './company-groups/company-group/company-group.component';
import { AllCasesListComponent } from './cases/all-cases-list/all-cases-list.component';
import { InstructedCasesListComponent } from './cases/instructed-cases-list/instructed-cases-list.component';
import { OnholdCasesListComponent } from './cases/onhold-cases-list/onhold-cases-list.component';
import { CompletedCasesListComponent } from './cases/completed-cases-list/completed-cases-list.component';
import { CancelledCasesListComponent } from './cases/cancelled-cases-list/cancelled-cases-list.component';
import { ClosedCasesListComponent } from './cases/closed-cases-list/closed-cases-list.component';
import { UninstructedCaseListComponent } from './uninstructed-case-list/uninstructed-case-list.component';

const routes: Routes = [
   {
      path: 'login',
      component: LoginComponent
   },
   {
      path: 'forgotpassword',
      component: ForgotPasswordComponent
   },
   {
      path: 'resetpassword',
      component: ResetPasswordComponent
   },
   {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardService],
    children: [
      {
          path: '',
          component: DashboardComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'search',
          component: SearchCaseComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'newcase',
          component: NewCaseComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'users',
          component: UserListComponent,
          canActivate: [RoleGuardService],
          data: {
            expectedRole: 'CanAdminUsers'
          }
      },
      {
          path: 'companygroup',
          component: CompanyGroupListComponent,
          canActivate: [RoleGuardService],
          data: {
            expectedRole: 'CanAdminUsers'
          }
      },
      {
          path: 'companygroup/:id',
          component: CompanyGroupComponent,
          canActivate: [RoleGuardService],
          data: {
            expectedRole: 'CanAdminUsers'
          }
      },
      {
          path: 'consultants',
          component: ConsultantListComponent,
          canActivate: [AuthGuardService],
          data: {
            expectedRole: 'CanAdminConsultants'
          }
      },
      {
          path: 'lenders',
          component: LendersListComponent,
          canActivate: [RoleGuardService],
          data: {
            expectedRole: 'CanAdminLenders'
          }
      },
      {
          path: 'lendersolicitors',
          component: LenderSolicitorsListComponent,
          canActivate: [RoleGuardService],
          data: {
            expectedRole: 'CanAdminLenders'
          }
      },
      {
          path: 'calendar',
          component: CalendarComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'actions',
          component: ActionsComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'unassignedfiles',
          component: UnassignedFilesComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'emailqueue',
          component: EmailQueueComponent,
          canActivate: [AuthGuardService]
      },
      {
          path: 'notificationslist',
          component: NotificationsListComponent,
          canActivate: [AuthGuardService]
      },
      {
        path: 'cases',
        component: AllCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/instructed',
        component: InstructedCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/onhold',
        component: OnholdCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/completed',
        component: CompletedCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/cancelled',
        component: CancelledCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/closed',
        component: ClosedCasesListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'cases/uninsturcted',
        component: UninstructedCaseListComponent,
        canActivate: [AuthGuardService]
      },
    ]
  },
  {
    path: 'case/:id',
    component: CaseComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'klyant/code/:code',
    component: KlyantAuthComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'klyant/error/:error',
    component: KlyantAuthComponent,
    canActivate: [AuthGuardService]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
